import MuiTableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import type { TablePaginationProps } from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TablePaginationActions from "./TablePaginationActions";
import { config } from "@/config";
function TableFooter(props: TablePaginationProps) {
  return (
    <MuiTableFooter>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={config.table.pageSizeOptions}
          colSpan={(props.colSpan ?? 0) + 1}
          count={props.count}
          rowsPerPage={props.rowsPerPage}
          page={props.page}
          labelRowsPerPage="Linhas por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
          }
          slotProps={{
            select: {
              inputProps: {
                "aria-label": "linhas por página",
              },
              native: true,
            },
          }}
          onPageChange={props.onPageChange}
          onRowsPerPageChange={props.onRowsPerPageChange}
          ActionsComponent={TablePaginationActions}
        />
      </TableRow>
    </MuiTableFooter>
  );
}

export default TableFooter;
